import { useLazyListStoresQuery } from 'api/client-domain/client-domain';
import { useTranslation } from 'react-i18next';
import { useLocationsToQueryString } from './search.hooks';
import { stringListSearchParam, stringSearchParam } from './search.utils';

export const useStoreIdListSearchParams = () => {
  const { t } = useTranslation();

  const [triggerStores] = useLazyListStoresQuery();
  const locationsToQueryString = useLocationsToQueryString();

  return [
    stringListSearchParam('storeIds', {
      defaultValue: ['ALL'],
      options: [
        {
          label: t('forms.fields.stores.allOption'),
          id: 'ALL',
        },
      ],
      asyncOptions: async () => {
        const stores = await triggerStores({ count: 1000, page: 0 });
        const dataArray =
          stores?.data?.stores.map(store => ({
            label: store.title,
            id: store.storeId,
          })) ?? [];

        return [
          {
            label: t('forms.fields.stores.allOption'),
            id: 'ALL',
          },
        ].concat(dataArray);
      },
      toQueryString: locationsToQueryString,
      filter: {
        type: 'MultiSelectFilter',
        label: t('forms.fields.stores.label'),
      },
    }),
  ];
};

export const useStoreIdSearchParam = (paramName = 'locationId') => {
  const { t } = useTranslation();
  const [triggerStores] = useLazyListStoresQuery();
  return [
    stringSearchParam(paramName, {
      defaultValue: 'ALL',
      options: [
        {
          label: t('forms.fields.stores.allOption'),
          id: 'ALL',
        },
      ],
      asyncOptions: async () => {
        const stores = await triggerStores({ count: 1000, page: 0 });
        const dataArray =
          stores?.data?.stores.map(store => ({
            label: store.title,
            id: store.storeId,
          })) ?? [];

        return [
          {
            label: t('forms.fields.stores.allOption'),
            id: 'ALL',
          },
        ].concat(dataArray);
      },
      filter: {
        type: 'SingleSelectFilter',
        label: t('forms.fields.stores.label'),
      },
    }),
  ];
};
